import { useMemo } from "react"

import * as turf from "@turf/turf"

import { useGeoServerFeaturesList } from "@l2r-front/l2r-geodata"
import { CANVAS_MIN_BBOX_WIDTH } from "@l2r-front/l2r-map"

import { useNetworksStateContext } from "../contexts/NetworksContext"

import { networksQueryKeys } from "./queryKeys"

export function useRoadBoundingBox(road) {

    const { selectedNetwork } = useNetworksStateContext()

    const { data: roadSegments, isLoading } = useGeoServerFeaturesList(
        networksQueryKeys.list({ road }),
        {
            layer: selectedNetwork?.referential?.layerSection,
            linear_location_road: road,
        },
        {
            enabled: !!road && !!selectedNetwork?.referential,
        })

    const roadBoundingBox = useMemo(() => {
        if (isLoading) {
            return null
        }
        if (!roadSegments || !roadSegments.length) {
            const [minLng, minLat, maxLng, maxLat] = turf.bbox(selectedNetwork.boundingBox)
            return {
                minLng,
                minLat,
                maxLng,
                maxLat,
            }
        }

        const roadFeature = turf.featureCollection(roadSegments)
        const [minLng, minLat, maxLng, maxLat] = turf.bbox(roadFeature)
        const lngOffset = Math.max((CANVAS_MIN_BBOX_WIDTH - (maxLng - minLng)), 0) / 2
        return ({
            minLng: minLng - lngOffset,
            minLat,
            maxLng: maxLng + lngOffset,
            maxLat,
        })
    }, [roadSegments, selectedNetwork, isLoading])

    return roadBoundingBox
}